import React from 'react'
import Table from 'react-bootstrap/Table'
import TableHeader from './TableHeader'
import TableRow from './TableRow'
import TableFooter from './TableFooter'
import { ATTableProps } from './ATTableProps'

const AppTable: React.FC<ATTableProps> = ({
  data,
  columns,
  handleRowSelected,
  hasFooter = false,
  footerData,
  footerColumns,
  footerColSpan,
  containsFooterHeader,
  striped = true,
  highlightSelectedRow,
  selectedRow,
  stickyFooter,
  selectedRowAttribute,
  popoverMessage,
}) => {
  return (
    <Table className="table-fixed" striped={striped} hover>
      <thead>
        <TableHeader columns={columns} />
      </thead>
      <tbody>
        <TableRow
          data={data}
          columns={columns}
          handleRowSelected={handleRowSelected}
          highlightSelectedRow={highlightSelectedRow}
          selectedRow={selectedRow}
          selectedRowAttribute={selectedRowAttribute}
          popoverMessage={popoverMessage}
        />
      </tbody>
      {hasFooter && (
        <tfoot className={`${stickyFooter ? 'sticky-footer' : ''}`}>
          <TableFooter
            data={footerData || []}
            columns={footerColumns || []}
            footerColSpan={footerColSpan || 0}
            containsHeader={containsFooterHeader ?? false}
          />
        </tfoot>
      )}
    </Table>
  )
}

export default React.memo(AppTable)
